const RequestRatingStarSvg = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none"><path fill="#FFA800" d="M9.316 11.743 5.986 9.66l-3.328 2.083a.35.35 0 0 1-.528-.383l.953-3.81L.108 5.028a.352.352 0 0 1 .202-.62l3.882-.272L5.66.494c.108-.266.545-.266.653 0l1.469 3.642 3.882.272a.352.352 0 0 1 .201.62L8.891 7.55l.952 3.81a.35.35 0 0 1-.527.383Z"/></svg>
    )
}

export default RequestRatingStarSvg;